import { Fragment, useState } from 'react';
import {
    Button, Box, DialogTitle, Dialog, Typography, DialogContent,
    TextField, FormControl, Select, MenuItem, DialogContentText, DialogActions, OutlinedInput, FormHelperText, InputLabel, FilledInput, List, ListItem, makeStyles, ListItemText, ListItemIcon, Tab, Tabs, Autocomplete,
    LinearProgress, styled, Paper, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material';
import { TextFieldElement, AutocompleteElement, SelectElement, SliderElement, FormContainer, DatePickerElement } from 'react-hook-form-mui';
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../redux/reducers/authSlice"
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useGetEventosAdjudicacionQuery, useAddEventosAdjudicacionMutation, useEditEventosAdjudicacionMutation, useDeleteEventosAdjudicacionMutation } from "../../../redux/reducers/eventosAdjudicacionSlice";
import { useGetCanalesAdjudicacionQuery } from "../../../redux/reducers/canalesAdjudicacionSlice"
import { useGetAdjudicacionesQuery, useEditAdjudicacionesMutation, useGetCanalesAdjudicacionesQuery, useGetAdjudicacionesByIdQuery, useAddAdjudicacionesMutation, useDeleteAdjudicacionesMutation } from "../../../redux/reducers/adjudicacionesSlice";
import { useGetDepartamentosQuery, useAddDepartamentoMutation, useEditDepartamentoMutation, useClasesContratosQuery, useDeleteDepartamentosMutation } from "../../../redux/reducers/departamentosSlice";
import { useGetContratosQuery } from "../../../redux/reducers/contratosSlice";

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IconButton from '@mui/material/IconButton';
import InsertInvitationRounded from '@mui/icons-material/InsertInvitationRounded';
import FiberManualRecordRounded from '@mui/icons-material/FiberManualRecordRounded';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import dayjs from 'dayjs';
import Grid from '@mui/material/Grid';
import Notification from "../../../components/Notification";
import { removeEmpty } from "../../../lib/utils/index.js";
import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { useForm, useController, Controller } from 'react-hook-form' // instead of react-hook-form


export default function EventosAdjudicacionCat() {

    const { data: eventos, isError, isLoading } = useGetEventosAdjudicacionQuery();
    const { data: adjudicaciones, isSuccess: adjudicacionesIsSucces } = useGetAdjudicacionesQuery();
    const { data: canalesAdjudicacion, isSuccess: canalesAdjudicacionIsSucces } = useGetCanalesAdjudicacionQuery();
    const { data: departamentos, isSuccess: departamentosIsSucces } = useGetDepartamentosQuery();
    const { data: clasesContratos, isSuccess: clasesContratosIsSucces } = useClasesContratosQuery();
    const { data: contratos } = useGetContratosQuery();

    const [editEventosAdjudicacion] = useEditEventosAdjudicacionMutation();
    const [deleteEventosAdjudicacion] = useDeleteEventosAdjudicacionMutation();

    const [eventMoreDetail, setEventMoreDetail] = useState([]); //A: cuando se hace click en el boton de mas detalles, se guarda el edificio en esta variable
    const [showEventMoreDetail, setShowEventMoreDetail] = useState(false);
    const openMoreDetail = () => setShowEventMoreDetail(true);
    const closeMoreDetail = () => setShowEventMoreDetail(false);

    const Header = (props) => {
        return (<Fragment>
            <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>Eventos de Adjudicación</Typography>
            {isLoading && <p>Cargando</p>}
            {isError && <p>Ha ocurrido un error</p>}
        </Fragment>);
    };

    const EventosAdjudicacionTable = (props) => {
        const currentUser = useSelector(selectCurrentUser);
        let esEjecutivoCuentasUser = currentUser.roles.map(r => r === 'Ejecutivo de Cuentas');
        const [selectedRows, setSelectedRows] = useState([]);
        let rows = Object.values(eventos?.entities || []);

        const columns = [
            { field: 'eventoAdjudicacionId', headerName: 'ID', width: 100 },
            { field: 'fechaEvento', headerName: 'Fecha de Evento', flex: 1, renderCell: v => (new Date(parseInt(v.row.fechaEvento))).toLocaleString().split(',')[0] },
            { field: 'fechaAnuncio', headerName: 'Fecha de Anuncio', flex: 1, renderCell: v => (new Date(parseInt(v.row.fechaAnuncio))).toLocaleString().split(',')[0] },
            { field: 'fechaCreacion', headerName: 'Fecha de Creación', flex: 1, renderCell: v => (new Date(parseInt(v.row.fechaCreacion))).toLocaleString().split(',')[0] },
            { field: 'fechaInicioLicitacionDineraria', headerName: 'Inicio de Licitación', flex: 1, renderCell: v => (new Date(parseInt(v.row.fechaInicioLicitacionDineraria))).toLocaleString().split(',')[0] },
            { field: 'fechaFinalizacionLicitacionDineraria', headerName: 'Finalización de Licitación', flex: 1, renderCell: v => (new Date(parseInt(v.row.fechaFinalizacionLicitacionDineraria))).toLocaleString().split(',')[0] },
            {
                headerName: 'Detalles', flex: 1, renderCell: v => <Button component="button" variant="contained" size="small" onClick={() => {
                    setEventMoreDetail(v.row)
                    openMoreDetail()
                }}> Ver </Button >
            }
        ];

        const BtnBar = (props) => {
            const [showNuevoEventoAdjudicacionForm, setShowNuevoEventoAdjudicacionForm] = useState(false);

            const [showBorrarEventoForm, setShowBorrarEventoForm] = useState(false);
            const [estamosBorrando, setEstamosBorrando] = useState(false);

            const openForm = () => setShowNuevoEventoAdjudicacionForm(true);
            const closeForm = () => setShowNuevoEventoAdjudicacionForm(false);
            const openDeleteForm = () => setShowBorrarEventoForm(true);
            const closeDeleteForm = () => setShowBorrarEventoForm(false);
            const [creando, setCreando] = useState(false);

            let evnAdjDflt = {
                fechaEvento: dayjs(),
                fechaAnuncio: dayjs(),
                fechaCreacion: dayjs(),
                fechaInicioLicitacionDineraria: dayjs(),
                fechaFinalizacionLicitacionDineraria: dayjs(),
                adjudicaciones: []
            };
            const [estamosEditando, setEstamosEditando] = useState(evnAdjDflt);

            function handleAdd() {
                setCreando(true);
                setEstamosEditando(evnAdjDflt);
                openForm();
            };

            function handleEdit() {
                setCreando(false);
                let eAdjSelect = eventos.entities[selectedRows[0]];
                if (eAdjSelect) {
                    eAdjSelect = {
                        ...eAdjSelect,
                        fechaEvento: parseInt(eAdjSelect.fechaEvento),
                        fechaAnuncio: parseInt(eAdjSelect.fechaAnuncio),
                        fechaCreacion: parseInt(eAdjSelect.fechaCreacion),
                        fechaInicioLicitacionDineraria: parseInt(eAdjSelect.fechaInicioLicitacionDineraria),
                        fechaFinalizacionLicitacionDineraria: parseInt(eAdjSelect.fechaFinalizacionLicitacionDineraria),
                    }
                    setEstamosEditando({ ...eAdjSelect });
                    openForm();
                }
            };

            function handleDeleteSubmit() {
                let eventosSeleccionados = eventos.entities[selectedRows.map(id => id === parseInt(id))];
                setEstamosBorrando(eventosSeleccionados);
                openDeleteForm();
            };

            const BorrarEventoForm = (props) => {
                let eventos = selectedRows.map(id => parseInt(id)).sort();

                let sonEventos = eventos.length !== 1 && eventos.length > 0;

                const borrar = () => {
                    deleteEventosAdjudicacion(selectedRows.map(id => parseInt(id))).unwrap()
                        .then(console.log)
                        .catch(console.log)
                    setEstamosBorrando(false);
                    setSelectedRows([]);
                    closeForm();
                }
                return (
                    <Fragment>
                        <Dialog onClose={closeDeleteForm} open={showBorrarEventoForm} maxWidth="xs">
                            <DialogTitle>{sonEventos ? 'Borrando Eventos' : 'Borrando Evento'}</DialogTitle>
                            <DialogContent dividers>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            {sonEventos ? '¿Quiere borrar los eventos seleccionados?' : '¿Quiere borrar el evento seleccionado?'}
                                        </Grid>
                                        <List>
                                            {eventos.map(id => (
                                                <ListItem key={`list-item-borrarevento-${id}`} >
                                                    <ListItemIcon><InsertInvitationRounded></InsertInvitationRounded></ListItemIcon>
                                                    <ListItemText>{`ID:  ${id}`}</ListItemText>
                                                </ListItem>))}
                                        </List>
                                        <Grid item xs={12}>

                                            <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                <Button variant="contained" onClick={borrar} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                <Button variant="outlined" onClick={closeDeleteForm}>{"Cancelar"}</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </DialogContent>
                        </Dialog>
                    </Fragment>
                )

            }
            //Manejo Adjudicaciones
            const [editAdjudicacion] = useEditAdjudicacionesMutation();
            const [deleteAdjudicaciones] = useDeleteAdjudicacionesMutation();
            const [addAdjudicacion] = useAddAdjudicacionesMutation();

            let dptosAdj = Object.values(adjudicaciones?.entities || {}).map(a => a.departamentoId)
            // Funciones para formularios
            const getOptionsDptos = () => {
                let optionsDptos = Object.values(departamentos?.entities || {})
                //.filter(d => { if (!dptosAdj.includes(d.departamentoId)) { return d } })
                console.log(optionsDptos)
                return optionsDptos.map(d => ({ id: d.departamentoId, label: 'ID ' + d.departamentoId + ' - Ed.: ' + d.edificioId + ' - Piso: ' + d.piso + ' - U.F.: ' + d.uniFuncional + ' - Estado: ' + (dptosAdj.includes(d.departamentoId) ? ' Adjudicado' : 'No adjudicado') }))
            };
            const getOptionsCanal = () => {
                let optionsCanal = Object.values(canalesAdjudicacion?.entities || {}).map(ca => ({ id: ca.canalId, label: ca.nombreCanal }))
                return optionsCanal
            };
            const getOptionsContratos = () => {
                return Object.values(contratos?.entities || {}).map(c => ({ ...c, id: c.contratoId, label: 'ID: ' + c.contratoId + ' - Tipo: ' + clasesContratos.filter(cc => c.claseContratoId === cc.claseContratoId).map(cc => cc.descripcion) }))
            };
            const NuevoEventoAdjudicacionForm = (props) => {
                let datesKeys = ['fechaEvento', 'fechaAnuncio', 'fechaCreacion', 'fechaInicioLicitacionDineraria', 'fechaFinalizacionLicitacionDineraria'];
                const [addEventosAdjudicacion] = useAddEventosAdjudicacionMutation();
                const [errores, setErrores] = useState([]);
                let eventoAdjudicacionAux = { ...dayjs(props.eventoAdjudicacion) };
                // datesKeys.forEach(k => eventoAdjudicacionAux[k] != null);
                const [eventoAdjudicacion, setEventoAdjudicacion] = useState(creando ? { ...eventoAdjudicacionAux, adjudicaciones: [] } : { ...estamosEditando });

                // States y variables de Adjudicaciones
                let adjDflt = {
                    canalId: '',
                    eventoAdjudicacionId: props.eventoAdjudicacion.eventoAdjudicacionId ? props.eventoAdjudicacion.eventoAdjudicacionId : '',
                    departamentoId: '',
                    fechaAdjudicacion: dayjs(),
                    contratoId: ''
                };
                let adjsDeEvento = Object.values(adjudicaciones?.entities || {}).filter(a => a.eventoAdjudicacionId === props.eventoAdjudicacion.eventoAdjudicacionId).map(a => ({ ...a, fechaAdjudicacion: parseInt(a.fechaAdjudicacion) }));
                const [adjs, setAdjs] = useState(adjsDeEvento ? adjsDeEvento : [])
                const [deleteAdjs, setDeleteAdjs] = useState([])
                //Funciones para opciones de formulario

                // Funciones Para Manejar Adjudicaciones
                function handleDeleteAdj(id) { //Borra Adjs de la lista no de la DB
                    setDeleteAdjs([...deleteAdjs, id]);
                    setAdjs([...adjs].filter(a => a.adjudicacionId !== id));
                };
                const handleAdjChange = (value, index, propiedad) => {
                    let newAdjs = [...adjs];
                    console.log(' este es el value ' + value + ' este es el index: ' + index + ' este es el newAdjs: ' + newAdjs);

                    if (newAdjs[index] === null || newAdjs[index] === undefined) newAdjs[index] = {};
                    if (propiedad === 1) { newAdjs[index] = { ...newAdjs[index], canalId: value } };
                    if (propiedad === 3) { newAdjs[index] = { ...newAdjs[index], departamentoId: value } };
                    if (propiedad === 4) { newAdjs[index] = { ...newAdjs[index], fechaAdjudicacion: value.valueOf() } };
                    if (propiedad === 5) { newAdjs[index] = { ...newAdjs[index], contratoId: value } };

                    setAdjs(newAdjs);
                    console.log(newAdjs);
                }
                //Funcion cambios en formulario
                function handleSubmit() {
                    let estamosEditando = props.eventoAdjudicacion.eventoAdjudicacionId;
                    //check if all values in obj are empty strings
                    setErrores([]);
                    let huboError = false; //FIX: setState es una funcion asincronica, no se puede usar como condicion la logintud del array errores


                    function isEmpty(obj) {
                        for (var key in obj) {
                            if (key !== 'fecha' && obj[key] !== "") {
                                return false;
                            }
                        }
                        return true;
                    }

                    if (isEmpty(eventoAdjudicacion)) {
                        setErrores(['Debe completar al menos un campo']);
                        huboError = true;
                    }

                    console.log(eventoAdjudicacion)
                    eventoAdjudicacion.fechaEvento = eventoAdjudicacion.fechaEvento.valueOf();
                    eventoAdjudicacion.fechaAnuncio = eventoAdjudicacion.fechaAnuncio.valueOf();
                    eventoAdjudicacion.fechaCreacion = eventoAdjudicacion.fechaCreacion.valueOf();
                    eventoAdjudicacion.fechaInicioLicitacionDineraria = eventoAdjudicacion.fechaInicioLicitacionDineraria.valueOf();
                    eventoAdjudicacion.fechaFinalizacionLicitacionDineraria = eventoAdjudicacion.fechaFinalizacionLicitacionDineraria.valueOf();

                    Object.keys(eventoAdjudicacion).forEach(k => eventoAdjudicacion[k] = isNaN(eventoAdjudicacion[k]) ? null : eventoAdjudicacion[k]); //A: clean nan values and convert strings or floats to ints
                    // datesKeys.forEach(k => eventoAdjudicacion[k] = eventoAdjudicacion[k] ? parseInt((eventoAdjudicacion[k])) : eventoAdjudicacion[k]); //A: HAY QUE CONVERTIRLO A MILISEGUNDOS
                    //setEventoAdjudicacion({ ...eventoAdjudicacion, adjudicaciones: [... adjs] })
                    console.log(eventoAdjudicacion)

                    if (creando) {
                        console.log('Adentro del if')
                        console.log(eventoAdjudicacion)
                        adjs.forEach(a => {
                            eventoAdjudicacion.adjudicaciones.push(a);
                        })
                    }
                    if (estamosEditando) {
                        eventoAdjudicacion.eventoAdjudicacionId = props.eventoAdjudicacion.eventoAdjudicacionId;
                        editEventosAdjudicacion(eventoAdjudicacion).unwrap()
                            .then(console.log)
                            .catch(console.log);
                    } else {
                        console.log('ANTES DE CREAR')
                        console.log(eventoAdjudicacion)
                        removeEmpty(eventoAdjudicacion);
                        addEventosAdjudicacion(eventoAdjudicacion).unwrap()
                            .then(console.log)
                            .catch(console.log);
                    }
                    // Acciones Adjudicaciones
                    console.log('ADJ Cuando se va a submit :  ')
                    console.log(adjs)
                    if (estamosEditando) {
                        //Borrar Dptos
                        setDeleteAdjs(deleteAdjs.filter(a => { return typeof a.adjudicacionId !== 'string' }));
                        if (deleteAdjs) {
                            deleteAdjudicaciones(deleteAdjs.map(id => parseInt(id))).unwrap()
                                .then(console.log)
                                .catch(console.log)
                            setDeleteAdjs([])
                        }
                        //Agregar nuevas Licitaciones
                        let newAdjs = adjs.filter(a => { return typeof a.adjudicacionId === 'string' })
                        newAdjs.map(a => {
                            delete a.adjudicacionId
                        });
                        console.log('ADJ NUEVAS CUANDO SE LE SACA EL ID')
                        newAdjs.forEach(adj => {
                            if (isEmpty(adj)) {
                                setErrores(['Debe completar al menos un campo de la adjudicación:']);
                                huboError = true;
                            } else {
                                removeEmpty(adj);
                                addAdjudicacion(adj).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            }
                        });
                        //Editar Adjudicaciones
                        setAdjs(adjs.filter(a => { return typeof a.adjudicacionId !== 'string' }))
                        console.log('ESTO SON LAS ADJS QUE SE EDITAN')
                        console.log(adjs)
                        adjs.forEach(adj => {
                            if (isEmpty(adj)) {
                                setErrores(['Debe completar al menos un campo de la adjudicación:']);
                                huboError = true;
                            }
                            if (estamosEditando) {
                                editAdjudicacion(adj).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            }
                        });
                    }

                }

                return (
                    <Fragment>
                        <Dialog onClose={closeForm} open={showNuevoEventoAdjudicacionForm} maxWidth="xl">
                            <DialogTitle>{creando ? 'Crear nuevo evento' : `Editar evento ID: ${props.eventoAdjudicacion.eventoAdjudicacionId}`}</DialogTitle>
                            <DialogContent dividers>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }} container spacing={2} >
                                    <div >
                                        <FormContainer defaultValues={{ ...eventoAdjudicacion }} onSuccess={handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2} style={{ 'padding-top': '20px' }}>
                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                label="Fecha de evento"
                                                                inputFormat="MM/DD/YYYY"
                                                                value={eventoAdjudicacion.fechaEvento}
                                                                onChange={(v) => setEventoAdjudicacion({ ...eventoAdjudicacion, fechaEvento: v })}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                required
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={2} style={{ 'padding-top': '20px' }}>
                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                label="Fecha de anuncio"
                                                                inputFormat="MM/DD/YYYY"
                                                                value={eventoAdjudicacion.fechaAnuncio}
                                                                onChange={(v) => setEventoAdjudicacion({ ...eventoAdjudicacion, fechaAnuncio: v })}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                required
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={2} style={{ 'padding-top': '20px' }}>
                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                label="Fecha de creacion"
                                                                inputFormat="MM/DD/YYYY"
                                                                value={eventoAdjudicacion.fechaCreacion}
                                                                onChange={(v) => setEventoAdjudicacion({ ...eventoAdjudicacion, fechaCreacion: v })}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                required
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={2} style={{ 'padding-top': '20px' }}>
                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                label="Inicio de la licitación"
                                                                inputFormat="MM/DD/YYYY"
                                                                value={eventoAdjudicacion.fechaInicioLicitacionDineraria}
                                                                onChange={(v) => setEventoAdjudicacion({ ...eventoAdjudicacion, fechaInicioLicitacionDineraria: v })}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                required
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={2} style={{ 'padding-top': '20px' }}>
                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DesktopDatePicker
                                                                label="Finalización de la licitación"
                                                                inputFormat="MM/DD/YYYY"
                                                                value={eventoAdjudicacion.fechaFinalizacionLicitacionDineraria}
                                                                onChange={(v) => setEventoAdjudicacion({ ...eventoAdjudicacion, fechaFinalizacionLicitacionDineraria: v })}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                required
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid dividers xs={12} style={{ 'padding': '0.5rem' }}>
                                                <Typography>Licitaciones</Typography>
                                            </Grid>
                                            <FormContainer />
                                            <Fragment>
                                                {adjs.map((adj, i) => {
                                                    return (
                                                        <FormContainer defaultValues={{ ...adj }} key={`form-container-adjudicacion-${adj.adjudicacionId}`}>
                                                            <Grid container spacing={0.5} dividers="true" key={'adj' + adj.adjudicacionId} >
                                                                <Grid item xs={0.5} style={{ 'paddingTop': '20px', 'marginRight': '35px' }}>
                                                                    <List>
                                                                        <ListItem>
                                                                            <ListItemText>{typeof adj.adjudicacionId !== 'string' ? `ID:  ${adj.adjudicacionId}` : `Nueva Licitación`}</ListItemText>
                                                                        </ListItem>
                                                                    </List>
                                                                </Grid>

                                                                <Grid item xs={3} style={{ 'paddingTop': '28px', 'marginLeft': '15px' }}>
                                                                    <SelectElement
                                                                        sx={{ width: '100%' }}
                                                                        label="Departamento"
                                                                        value={adj.departamentoId}
                                                                        name={'departamentoId'}
                                                                        required
                                                                        options={getOptionsDptos()}
                                                                        onChange={(value) => { handleAdjChange(value, i, 3) }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2} style={{ 'paddingTop': '28px', 'marginLeft': '15px' }}>
                                                                    <SelectElement
                                                                        sx={{ width: '100%' }}
                                                                        label="Canal de licitación"
                                                                        value={adj.canalId}
                                                                        name={'canalId'}
                                                                        required
                                                                        options={getOptionsCanal()}
                                                                        onChange={(value) => { handleAdjChange(value, i, 1) }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={2} style={{ 'paddingTop': '20px' }}>
                                                                    <FormControl sx={{ m: 1 }} variant="outlined">
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DesktopDatePicker
                                                                                label="Fecha de licitación"
                                                                                name={'fechaAdjudicacion'}
                                                                                value={adj.fechaAdjudicacion}
                                                                                inputFormat="MM/DD/YYYY"
                                                                                onChange={(value) => { handleAdjChange(value, i, 4) }}
                                                                                renderInput={(params) => <TextField {...params} />}
                                                                            />
                                                                        </LocalizationProvider>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={3} style={{ 'paddingTop': '30px' }}>
                                                                    <SelectElement
                                                                        sx={{ width: '100%' }}
                                                                        label="Contrato"
                                                                        value={adj.contratoId}
                                                                        name={'contratoId'}
                                                                        options={getOptionsContratos()}
                                                                        onChange={(value) => { handleAdjChange(value, i, 5) }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={0.5} style={{ 'paddingTop': '30px' }}>
                                                                    <IconButton className="mb-3" variant="contained" color='danger' onClick={() => handleDeleteAdj(adj.adjudicacionId)}><DeleteIcon /></IconButton >
                                                                </Grid>
                                                            </Grid>
                                                        </FormContainer>
                                                    )
                                                })}
                                                <Grid item xs={12} style={{ padding: '0.5rrem' }}>
                                                    <Button onClick={() => { setAdjs([...adjs, { ...adjDflt, adjudicacionId: uuid(), eventoAdjudicacionId: props.eventoAdjudicacion.eventoAdjudicacionId }]) }}>Agregar</Button>
                                                </Grid>
                                            </Fragment>
                                        </FormContainer>
                                    </div>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sx={{ color: 'error.main' }}>
                                            {errores.length > 0 && errores.map((error, i) => <p style={{ marginLeft: '8px' }} key={`erroradjudicacion-${i}`}>- {error}</p>)}
                                        </Grid>

                                        <Grid item xs={12} style={{ marginBottom: '8px' }}>

                                            <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                <Button variant="contained" onClick={handleSubmit} sx={{ marginRight: '10px' }}>{"Aceptar"}</Button>
                                                <Button variant="outlined" onClick={closeForm}>{"Cancelar"}</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </DialogContent>
                        </Dialog>
                    </Fragment >
                )
            };
            const EventMoreDetailsModal = (props) => {

                console.log(dptosAdj)
                let eventoId = props.evento.eventoAdjudicacionId;
                let adjDeEvento = Object.values(adjudicaciones?.entities || {}).filter(a => a.eventoAdjudicacionId === eventoId);

                //funciones, variables y states de Adjudicaciones
                // States y variables de Adjudicaciones
                let rowsAdj = Object.values(adjDeEvento || []);
                const [selectedRowsAdj, setSelectedRowsAdj] = useState([]);
                let adjDflt = {
                    canalId: '',
                    eventoAdjudicacionId: '',
                    departamentoId: '',
                    fechaAdjudicacion: new Date(),
                    contratoId: ''
                };
                //Función para info de la grid.
                const getDescripcionCanal = (canalId) => {
                    let canales = Object.values(canalesAdjudicacion?.entities || {});
                    return canales.find(c => c.canalId === parseInt(canalId))?.nombreCanal;
                }

                const columnsAdj = [
                    //{ field: 'EdificioId', headerName: 'ID', width:100},
                    { field: 'adjudicacionId', headerName: 'ID', flex: 2 },
                    { field: 'canalId', headerName: 'Canal de adjudicacion', flex: 24, valueGetter: v => getDescripcionCanal(v.row.canalId) },
                    { field: 'departamentoId', headerName: 'Departamento ID', flex: 12 },
                    { field: 'contratoId', headerName: 'Contrato ID', flex: 12 },
                    { field: 'eventoAdjudicacionId', headerName: 'Evento ID', flex: 12 },
                    { field: 'fechaAdjudicacion', headerName: 'Fecha de Adjudicacion', flex: 12, renderCell: v => (new Date(parseInt(v.row.fechaAdjudicacion))).toLocaleString().split(',')[0] },
                ];

                const AdjBtnBar = (props) => {
                    const [adj, setAdj] = useState([])

                    const [creando, setCreando] = useState([false])
                    const [deleteAdjs, setDeleteAdjs] = useState([])
                    const [showNuevoAdjForm, setShowNuevoAdjForm] = useState(false);
                    const openForm = () => setShowNuevoAdjForm(true);
                    const closeForm = () => setShowNuevoAdjForm(false);

                    const [showBorrarAdjForm, setShowBorrarAdjForm] = useState(false);
                    const [estamosBorrando, setEstamosBorrando] = useState(null);
                    const openDeleteForm = () => setShowBorrarAdjForm(true);
                    const closeDeleteForm = () => setShowBorrarAdjForm(false);

                    // Funciones Para Manejar Adjudicaciones

                    function handleAddAdj() {
                        setCreando(true);
                        setAdj(adjDflt);
                        console.log(adj)
                        openForm();
                    }

                    function handleEditAdj() {
                        setCreando(false)
                        let adjSelect = adjudicaciones.entities[selectedRowsAdj[0]];
                        console.log(adjSelect)
                        if (adjSelect) {
                            setAdj({ ...adjSelect, fechaAdjudicacion: parseInt(adjSelect.fechaAdjudicacion) });
                            openForm();
                        }
                    }

                    function handleDeleteSubmitAdj() {
                        let adjsSelect = adjudicaciones.entities[selectedRowsAdj.map(id => id === parseInt(id))];
                        setDeleteAdjs(adjsSelect);
                        openDeleteForm();
                    };
                    const BorrarAdjForm = (props) => {
                        let adjs = selectedRowsAdj.map(id => parseInt(id)).sort();
                        let sonAdjs = adjs.length !== 1 && adjs.length > 0;

                        const borrar = () => {
                            deleteAdjudicaciones(selectedRowsAdj.map(id => parseInt(id))).unwrap()
                                .then(console.log)
                                .catch(console.log)
                            setEstamosBorrando(false);
                            setSelectedRowsAdj([]);
                            closeForm();
                        }
                        return (
                            <Fragment>
                                <Dialog onClose={closeDeleteForm} open={showBorrarAdjForm} maxWidth="xs">
                                    <DialogTitle>{sonAdjs ? 'Borrando Adjudicaciones' : 'Borrando Adjudicación'}</DialogTitle>
                                    <DialogContent dividers>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    {sonAdjs ? '¿Quiere borrar las adjudicaciones seleccionadas?' : '¿Quiere borrar la adjudicación seleccionada?'}
                                                </Grid>
                                                <List>
                                                    {adjs.map(id => (
                                                        <ListItem key={'adj' + adjs[id]} >
                                                            <ListItemIcon><HomeRoundedIcon></HomeRoundedIcon></ListItemIcon>
                                                            <ListItemText>{`ID:  ${id}`}</ListItemText>
                                                        </ListItem>))}
                                                </List>
                                                <Grid item xs={12}>

                                                    <div style={{ marginTop: '10px', marginLeft: '5px' }}>
                                                        <Button variant="contained" onClick={borrar} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                        <Button variant="outlined" onClick={closeDeleteForm}>{"Cancelar"}</Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </DialogContent>
                                </Dialog>
                            </Fragment>
                        )
                    }
                    const NuevoAdjForm = (props) => {
                        const [errores, setErrores] = useState([]);
                        const [form, setForm] = useState(adj)

                        //Funciones para opciones de formulario

                        const getOptionsEventos = () => {
                            return Object.values(eventos?.entities || {}).map(e => ({ ...e, id: e.eventoAdjudicacionId, label: 'ID: ' + e.eventoAdjudicacionId }))
                        };
                        // //Funcion cambios en formulario
                        const handleAdjChange = (value, propiedad) => {
                            console.log('Estoy en adj change')
                            console.log(value)
                            let newAdj = { ...form };
                            if (propiedad === 1) { newAdj = { ...newAdj, canalId: value } }
                            if (propiedad === 2) { newAdj = { ...newAdj, eventoAdjudicacionId: value } }
                            if (propiedad === 3) { newAdj = { ...newAdj, departamentoId: value } }
                            if (propiedad === 4) { newAdj = { ...newAdj, fechaAdjudicacion: parseInt(value).valueOf() } }
                            if (propiedad === 5) { newAdj = { ...newAdj, contratoId: value } }
                            console.log(newAdj)
                            setForm(newAdj);
                        }
                        //Función Submit
                        const handleSubmitAdj = () => {

                            let huboError = false; //FIX: setState es una funcion asincronica, no se puede usar como condicion la logintud del array errores
                            setErrores([]);
                            let adjAux = form
                            console.log(adjAux)
                            function isEmpty(obj) {
                                if ((obj.canalId === '') || (obj.eventoAdjudicacionId === '')) {
                                    return true;
                                }
                                return false;
                            }
                            if (isEmpty(adjAux)) {
                                setErrores(['Debe completar el campo de "Evento", "Departamento" y "Canal"']);
                                huboError = true;
                            } else {
                                huboError = false
                            }
                            console.log(huboError)
                            if (huboError) return;
                            adjAux.fechaAdjudicacion = adjAux.fechaAdjudicacion.valueOf();
                            console.log('Esto es lo que va al submit')
                            console.log(adjAux)
                            if (creando === false) {
                                // console.log('ESTO ES LO QUE VA AL SUBMIT CUANDO EDITO')
                                // console.log(adjAux)
                                adjAux.adjudicacionId = props.adj.adjudicacionId
                                editAdjudicacion(adjAux).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            } else {
                                // console.log('ESTO ES LO QUE VA AL SUBMIT CUANDO CREO')
                                // console.log(adjAux)
                                removeEmpty(adjAux);
                                addAdjudicacion(adjAux).unwrap()
                                    .then(console.log)
                                    .catch(console.log);
                            };
                        }
                        return (
                            <Fragment>

                                <Dialog
                                    open={showNuevoAdjForm}
                                    onClose={closeForm}
                                    maxWidth='md'
                                >
                                    <DialogTitle>{creando ? 'Crear nueva Adjudicación' : `Editar Adjudicación ID: ${props.adj.adjudicacionId}`}</DialogTitle>
                                    <DialogContent dividers>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', with: 900 }} >
                                            <div>
                                                <FormContainer defaultValues={{ ...adj }} onSuccess={handleSubmitAdj}>
                                                    <Grid container spacing={2} dividers="true" key={'adj' + adj.adjudicacionId} >
                                                        <Grid item xs={4} style={{ 'paddingTop': '20px' }}>
                                                            <SelectElement
                                                                sx={{ width: '100%' }}
                                                                label="Canal de licitación"
                                                                name="canalId"
                                                                onChange={(value) => handleAdjChange(value, 1)}
                                                                required
                                                                options={getOptionsCanal()}
                                                            />

                                                        </Grid>
                                                        <Grid item xs={3} style={{ 'paddingTop': '20px' }}>
                                                            <SelectElement
                                                                sx={{ width: '100%' }}
                                                                label="Evento de licitación"
                                                                name="eventoAdjudicacionId"
                                                                onChange={(value) => handleAdjChange(value, 2)}
                                                                required
                                                                options={getOptionsEventos()}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4} style={{ 'paddingTop': '20px' }}>
                                                            <FormControl variant="outlined">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DesktopDatePicker
                                                                        label="Fecha de licitación"
                                                                        inputFormat="MM/DD/YYYY"
                                                                        value={form.fechaAdjudicacion}
                                                                        onChange={(v) => setForm({ ...form, fechaAdjudicacion: v })}
                                                                        renderInput={(params) => <TextField {...params} />}
                                                                    />
                                                                </LocalizationProvider>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={5} style={{ 'paddingTop': '20px' }}>
                                                            <SelectElement
                                                                sx={{ width: '100%' }}
                                                                label="Contrato"
                                                                name="contratoId"
                                                                onChange={(value) => handleAdjChange(value, 5)}
                                                                options={getOptionsContratos()}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={5} style={{ 'paddingTop': '20px' }}>
                                                            <SelectElement
                                                                sx={{ width: '100%' }}
                                                                label="Departamento"
                                                                name="departamentoId"
                                                                required
                                                                onChange={(value) => handleAdjChange(value, 3)}
                                                                options={getOptionsDptos()}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </FormContainer>
                                            </div>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sx={{ color: 'error.main' }}>
                                                    {errores.length > 0 && errores.map((error, i) => <p style={{ marginLeft: '8px' }} key={'errDepartamento' + i}>- {error}</p>)}
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <div style={{ marginTop: '10px' }}>
                                                        <Button variant="contained" onClick={handleSubmitAdj} sx={{ marginRight: '5px' }}>{"Aceptar"}</Button>
                                                        <Button variant="outlined" onClick={closeForm}>{"Cancelar"}</Button>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </DialogContent>
                                </Dialog>
                            </Fragment>
                        )
                    }
                    return (
                        <Fragment>
                            <IconButton className="mb-3" variant="contained" color='primary' onClick={handleAddAdj}><AddIcon /></IconButton>
                            <IconButton className="mb-3" variant="contained" disabled={selectedRowsAdj.length !== 1} color='info' onClick={handleEditAdj}><EditIcon /></IconButton>
                            <IconButton className="mb-3" variant="contained" disabled={selectedRowsAdj.length === 0} color='danger' onClick={handleDeleteSubmitAdj}><DeleteIcon /></IconButton>
                            <NuevoAdjForm adj={adj}></NuevoAdjForm>
                            <BorrarAdjForm adj={adj}></BorrarAdjForm>
                        </Fragment>
                    )
                }
                return (

                    <Dialog
                        open={showEventMoreDetail}
                        onClose={closeMoreDetail}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={true}
                        maxWidth='lg'
                    >
                        <DialogTitle>{`Licitaciones del evento ID: ${eventoId}`}</DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ flexGrow: 1, padding: '2rem', height: 600, width: '100%', borderBottom: 1, borderColor: 'divider' }}>
                                <AdjBtnBar></AdjBtnBar>
                                <DataGrid
                                    getRowId={r => r.adjudicacionId}
                                    initialState={{
                                        sorting: {
                                            sortModel: [{ field: 'ID', sort: 'desc' }],
                                        },
                                    }}
                                    rows={rowsAdj}
                                    columns={columnsAdj}
                                    pageSize={100}
                                    rowsPerPageOptions={[5]}
                                    checkboxSelection
                                    // disableSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                    onSelectionModelChange={setSelectedRowsAdj}
                                    components={{
                                        Toolbar: () => {
                                            return <GridToolbarContainer><GridToolbarColumnsButton></GridToolbarColumnsButton> <GridToolbarFilterButton></GridToolbarFilterButton> <GridToolbarDensitySelector></GridToolbarDensitySelector>
                                                {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport></GridToolbarExport>
                                                    : ''}</GridToolbarContainer>
                                        }
                                    }}
                                    componentsProps={{
                                        toolbar: {
                                            showQuickFilter: true,
                                            quickFilterProps: { debounceMs: 500 },
                                        },
                                    }}
                                />
                            </Box>
                        </DialogContent>
                    </Dialog >
                )
            };
            return (
                <Fragment>
                    <IconButton className="mb-3" variant="contained" color='primary' onClick={handleAdd}><AddIcon /></IconButton>
                    <IconButton className="mb-3" variant="contained" disabled={selectedRows.length !== 1} color='info' onClick={handleEdit}><EditIcon /></IconButton>
                    <IconButton className="mb-3" variant="contained" disabled={selectedRows.length === 0} color='danger' onClick={handleDeleteSubmit}><DeleteIcon /></IconButton>
                    <NuevoEventoAdjudicacionForm eventoAdjudicacion={estamosEditando}></NuevoEventoAdjudicacionForm>
                    <BorrarEventoForm eventoAdjudicacion={estamosBorrando}></BorrarEventoForm>
                    <EventMoreDetailsModal evento={eventMoreDetail}></EventMoreDetailsModal>
                </Fragment>
            );
        };

        return (
            <Fragment>
                <BtnBar></BtnBar>
                <Box sx={{ height: 600, width: '100%' }}>
                    <DataGrid
                        getRowId={r => r.eventoAdjudicacionId}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'fecha', sort: 'desc' }],
                            },
                        }}
                        rows={rows}
                        columns={columns}
                        pageSize={100}
                        rowsPerPageOptions={[5]}
                        checkboxSelection
                        //disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        onSelectionModelChange={setSelectedRows}
                        components={{
                            Toolbar: () => {
                                return <GridToolbarContainer><GridToolbarColumnsButton></GridToolbarColumnsButton> <GridToolbarFilterButton></GridToolbarFilterButton> <GridToolbarDensitySelector></GridToolbarDensitySelector>
                                    {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport></GridToolbarExport>
                                        : ''}</GridToolbarContainer>
                            }
                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                    />
                </Box>
            </Fragment>
        );
    };
    return (
        <Fragment>
            <Header></Header>
            <EventosAdjudicacionTable></EventosAdjudicacionTable>
        </Fragment>
    )
}